var map = {
	"./botanicalSage.svg": 4366,
	"./classic.png": 1215,
	"./gildedArch.svg": 5110,
	"./goldDots.png": 1793,
	"./goldGlitter.png": 7830,
	"./marsalaFloral.png": 5052,
	"./modernMinimalist.svg": 1363,
	"./sakura.png": 4372,
	"./silverGlitter.png": 3174,
	"./sticker.png": 1802,
	"./sticker1.png": 2441,
	"./sticker2.png": 6354,
	"./sticker3.png": 7483,
	"./sticker4.png": 7572,
	"./wreath.png": 1914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1679;